<template>
  <div>
    <div id="CoreBenefits">
      <b-container fluid class="wrapper">
        <b-row align-h="center">
          <!-- <b-col lg="6" md="12" class="player">
            <img src="@/assets/images/player_image_randy.png" alt="Player" />
          </b-col> -->
          <b-col lg="12" md="12" class="benefitsList">
            <h1>Season Member Benefits</h1>
            <div class="line"></div>
            <!-- <p>Early Access to Tickets</p> -->
            <b-row align-h="center" class="accordion-wrapper">
              <b-col lg="12" xl="6">
                <div class="accordionContainer" style="">
                  <Accordion
                    uniquePrefix="one"
                    :accordionData="accordionData1"
                  />
                </div>
              </b-col>
              <b-col lg="12" xl="6">
                <div class="accordionContainer" style="">
                  <Accordion
                    uniquePrefix="two"
                    :accordionData="accordionData2"
                  />
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <p class="smallPrint">
              Please note, all seat locations, game availability and access to
              benefits are subject to change. Seating capacity may be restricted
              and/or vary throughout the 2024 season.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Banner bannerDivider="forth" />
  </div>
</template>

<script>
import { coreBenefitsData1, coreBenefitsData2 } from "@/data/benefitsData";
import { TweenLite } from "gsap/dist/gsap";
import Accordion from "@/components/sections/CoreBenefits/Accordion";
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "CoreBenefits",
  components: {
    Accordion,
    Banner,
  },
  data() {
    return {
      accordionData1: coreBenefitsData1(),
      accordionData2: coreBenefitsData2(),
      selectedCategory: "",
      activeItemKey: "",
    };
  },
  methods: {
    itemClicked(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;
      if (currentActiveEle) {
        this.activeItemKey = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0,
        });
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight,
        });
      }
    },
  },
  mounted() {
    if (this.accordionData && Object.keys(this.accordionData).length > 0) {
      this.selectedCategory = Object.keys(this.accordionData)[0];
    }
  },
};
</script>

<style lang="scss" scoped>
.accordion-wrapper {
  @media only screen and (max-width: $md) {
    padding-inline: 50px;
  }
  @media only screen and (max-width: $sm) {
    padding-inline: 0px;
  }
}
.accordionContainer {
  padding-inline: 40px;
  @media only screen and (max-width: $md) {
    padding-inline: 0;
  }
}
#CoreBenefits {
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/bgImage_babyblue.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .wrapper {
    max-width: 1500px;
    // padding: 0 100px;

    @media only screen and (max-width: $md) {
      padding: 0 50px;
    }
  }
  .player {
    padding-right: 20px;
    margin: 0;
    @media only screen and (max-width: $lg) {
      display: none;
    }
    img {
      width: 100%;
    }
  }
  .benefitsList {
    .line {
      background-color: $yellow;
      width: 492px;
      height: 5px;
      margin: 15px auto 1em;
      @media only screen and (max-width: "1190px") {
        width: 80%;
      }
    }
    h1 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 35px;
      line-height: 1;
      text-transform: uppercase;
      color: #00285e;
      text-align: center;
      @media only screen and (max-width: "1190px") {
        font-size: 25px;
      }
    }
    p {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      /* identical to box height */

      text-transform: uppercase;

      /* navy */

      color: #00285e;

      span {
        font-family: "Futura";
        font-weight: 700;
      }
    }
    .renewBtns {
      display: flex;
      justify-content: space-around;
      @media only screen and (max-width: $sm) {
        flex-wrap: wrap;
      }
      .renewBtn {
        margin-top: 30px;
        @media only screen and (max-width: $sm) {
          margin-top: 10px;
        }

        button {
          font-family: "UniversLTStd-LightCn";
          font-size: 16px;
          color: #000;
          background-color: $yellow !important;
          border-radius: 25px;
          padding: 13px 20px;
          text-transform: uppercase;
          max-width: 300px;
          margin: auto;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
  p.smallPrint {
    font-family: "Futura";
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    color: #161e26;
    margin-top: 20px;
  }
}
</style>
